import type { MyWorkspaceListItemResponse } from '@core/api/workspace/models';

export interface WorkspaceCompanyGroup {
  companyId: string;
  companyName: string;
  workspaces: MyWorkspaceListItemResponse[];
}

/** Groups workspaces by companyId, preserving first-seen company order. */
export function groupWorkspacesByCompany(
  workspaces: MyWorkspaceListItemResponse[],
): WorkspaceCompanyGroup[] {
  const groups: WorkspaceCompanyGroup[] = [];
  const indexByCompanyId = new Map<string, number>();

  for (const workspace of workspaces) {
    const companyId = workspace.companyId || '';
    const existingIndex = indexByCompanyId.get(companyId);

    if (existingIndex === undefined) {
      indexByCompanyId.set(companyId, groups.length);
      groups.push({
        companyId,
        companyName: workspace.companyName || 'Company',
        workspaces: [workspace],
      });
      continue;
    }

    groups[existingIndex].workspaces.push(workspace);
  }

  return groups;
}
